"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollablePaneContext = exports.ScrollbarVisibility = void 0;
var React = require("react");
/**
 * {@docCategory ScrollablePane}
 */
exports.ScrollbarVisibility = {
    auto: 'auto',
    always: 'always',
};
exports.ScrollablePaneContext = React.createContext({
    scrollablePane: undefined,
    window: undefined,
});
//# sourceMappingURL=ScrollablePane.types.js.map